export const canModifyScheduledMessage = (
  sendAt: string | Date
): { success: boolean; error?: string } => {
  try {
    return { success: true };
    const MINUTES_BEFORE_SEND_TO_ALLOW_DELETE = 2;
    const sendAtDate = new Date(sendAt);
    const now = new Date();
    if (sendAtDate < now) throw new Error(
      'Não é possível excluir uma mensagem agendada para um horário passado!'
    );
    const diffInMs = sendAtDate.getTime() - now.getTime();
    const diffInMinutes = diffInMs / 1000 / 60;
    if (diffInMinutes < MINUTES_BEFORE_SEND_TO_ALLOW_DELETE) throw new Error(
      `Faltam menos de ${MINUTES_BEFORE_SEND_TO_ALLOW_DELETE} minutos para o envio. Não é possível excluir.`
    );
  } catch (error) {
    return { success: false, error: error.message };
  }
  return { success: true };
};
